import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { deleteQualification, DELETE_QUALIFICATION} from "../../actions/student.action"

function* handleDeleteQualification(action) {
  try {
    const { data : resData} = yield call(studentAPI.deleteQualification, action.payload);
    //extract the data here     
    yield put(deleteQualification.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(deleteQualification.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* deleteQualificationSaga() {
  yield takeLatest(DELETE_QUALIFICATION.REQUEST, handleDeleteQualification);
}

export default deleteQualificationSaga;
